export const HIDE_DOCUMENTS_BULK_RENAME_TRIAL_PROMOTION_KEY = 'vdr-hide-documents-bulk-rename-trial-promotion-key';
